import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import style from './style.module.less'
import { Radio } from 'hljd'
import Store from './store'
import { observer } from 'mobx-react'

const SettingOption = ({ title, children }) => {
  return (
    <div className={style.option}>
      <div className={style.title}>{title}</div>
      <div>{children}</div>
    </div>
  )
}

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  componentDidMount() {
    this.store.getSetting()
  }

  render() {
    const header = ['团队管理', '团队设置']
    const { onChange, settingParams, configOptions } = this.store

    return (
      <HeaderView header={header} title="团队设置">
        <div style={{ marginTop: 30 }}>
          {configOptions.map(item => {
            const { title, name, options, disabled } = item
            return (
              <SettingOption key={name} title={title}>
                <Radio.Group
                  value={settingParams[name]}
                  name={name}
                  onChange={onChange}
                  disabled={disabled}
                >
                  {options.map(option => {
                    const { value, title } = option
                    return (
                      <Radio key={value} value={value}>
                        {title}
                      </Radio>
                    )
                  })}
                </Radio.Group>
              </SettingOption>
            )
          })}
        </div>
      </HeaderView>
    )
  }
}
